import { useState } from 'react';
import axiosInstance from '../../Services/axiosCommon';
// import { notification } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useToast } from '../Others/ToastServices';
import useNotification from './useNotification';
import { useSocket } from '../../Context/SocketContext';
import { useQueryClient } from '@tanstack/react-query';

const useEditFormData = () => {
  const [isLoading, setIsLoading] = useState(false);
  // const [ api, contextHolder ] = notification.useNotification();
  // const [ data, setData ] = useState(null);
  // const {handleSendNotification} = useNotification();
  const toast = useToast();
  const navigate = useNavigate()
  const queryClient = useQueryClient();

  function Oncancel(navigateUrl, state) {
    if (navigateUrl) {
      navigate(navigateUrl, { state });
    } else {
      navigate(-1);
    }
  }
  const {sendProfileNotification}  =useSocket();


  const editFormData = async (url, formData, resetForm, navigateUrl, stateToForward = {}) => {
    setIsLoading(true);

    try {
      const res = await axiosInstance.put(url, formData);
      if (res.data?.status === true) {
        // res.data?.data && setData();
        if (res.data.notification!==null || res.data.notification!==undefined || res.data.notification!==""){
          sendProfileNotification({...res.data.notification,type:1});
        }
        toast.open({
          type:"success",
          message:"Success",
          description: res.data?.msg || "Created Successfully."
        })
        queryClient.invalidateQueries();
        resetForm();
        navigate(`${navigateUrl}`, { state: { data : res.data?.data, ...stateToForward } }  );
      }
      else if(res.data?.status === false && res.data?.error){
        toast.open({
          type:"error",
          message:"Error",
          description: res.data.error || "Network error."
        })
      } 
      else {
        toast.open({
          type:"warning",
          message:"Warning",
          description: res.data?.msg || "Warning."
        })
      }
    } catch (err) {
    //   setError(err.message);
      console.log(err);
      toast.open({
        type:"error",
        message:"Error",
        description:  "Network error."
      })
    } finally {
      setIsLoading(false);
    }
  };

  return { editFormData, isLoading,  Oncancel };
};

export default useEditFormData;